module.exports = __webpack_public_path__ + "static/JG2-0dbcb763b1fda55f0e5aefb0cc46873d.png";